import React from 'react'

const About = () => {
  return (
    <section className="py-16 px-4 md:px-6">
      <div className="container mx-auto">
        <div className="section-bg">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold section-title-enhanced mb-6 text-center">
              🌟 About AuraSquare Events
            </h2>
            <p className="text-lg md:text-xl text-white leading-relaxed mb-6 text-justify">
              <strong>AuraSquare</strong> is Chennai's best & premium event management company, dedicated to delivering world-class entertainment and engagement solutions that leave a lasting impression. Whether it's a wedding that tells your love story, a corporate event that elevates your brand, or a birthday party that creates lifelong memories, we bring creativity, professionalism, and passion to every project across Chennai and all districts of Tamil Nadu.
            </p>
            <p className="text-lg md:text-xl text-white leading-relaxed mb-6 text-justify">
              From interactive carnival games and state-of-the-art photobooths to bespoke decorations and experiential setups, we transform ordinary gatherings into extraordinary brand experiences. Our team curates innovative, high-impact activities tailored for product launches, conferences, team-building events, weddings, birthdays, baby showers, engagements, college festivals, school annual days, and everything in between.
            </p>
            <p className="text-lg md:text-xl text-white leading-relaxed text-justify">
              With a perfect balance of creativity and professionalism, <strong>AuraSquare</strong> is your trusted partner in elevating events into experiences that inspire connection, excitement, and success.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
